import * as Role from '../constants/role';
import { canViewDigitadorReport } from './digitadorReportPermission';
import { canViewInspecaoReport } from './inspecaoReportPermission';
import { canViewUsoMutuoReport } from './usoMutuoReportPermission';

/**
 * Links para relatórios BI na listagem NSIRs.
 * Usa os mesmos critérios do menu V2 (supervisor, env, module config) — não role alone.
 */
export function getNsirBiReportLinks({ authData, userRole, moduleConfigurations }) {
  const links = [];

  if (canViewInspecaoReport({ authData, userRole })) {
    links.push({ label: 'Relatório de Inspeção', href: '/v2/relatorio-inspecao' });
  }
  if (canViewDigitadorReport({ authData, userRole })) {
    if (userRole === Role.DIGITADOR) {
      links.push({ label: 'Minha Digitação', href: '/v2/minha-digitacao' });
    } else {
      links.push({ label: 'Painel Digitação', href: '/v2/relatorio-digitacao' });
    }
  }
  if (canViewUsoMutuoReport({ authData, moduleConfigurations })) {
    links.push({ label: 'Relatório Uso Mutuo - Sucata', href: '/v2/relatorio-uso-mutuo' });
  }

  return links;
}

/**
 * Permissões de exportação na listagem NSIRs V2.
 * Exports BI (inspeção, digitadores): canView*.
 * Exports operacionais NSIR (edição, serviços, uso mútuo, financeiro planilha): isAdmin.
 * Export financeiro NSIR ≠ Relatório Financeiro BI (canViewFinanceiroReport).
 */
export function getNsirExportPermissions({ authData, userRole, isAdmin }) {
  return {
    inspecao: canViewInspecaoReport({ authData, userRole }),
    digitador: canViewDigitadorReport({ authData, userRole }) && userRole !== Role.DIGITADOR,
    financeiro: isAdmin,
    edit: isAdmin,
    servico: isAdmin,
    usoMutuo: isAdmin,
  };
}
